import { render, staticRenderFns } from "./ColumnVisibility.vue?vue&type=template&id=bd823ad2&scoped=true&"
import script from "./ColumnVisibility.vue?vue&type=script&lang=js&"
export * from "./ColumnVisibility.vue?vue&type=script&lang=js&"
import style0 from "./ColumnVisibility.vue?vue&type=style&index=0&id=bd823ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd823ad2",
  null
  
)

export default component.exports